// extracted by mini-css-extract-plugin
export var breadcrumb = "_1i-3";
export var breadcrumbArrow = "_1i-4";
export var breadcrumbs = "_1i-0";
export var link = "_1i-5";
export var sm = "_1i-1";
export var xs = "_1i-2";